<div class="inner" layout-vertical>
  <div layout layout-full-width layout-space-between>
    <div layout layout-align-items-center layout-full-width>
      <ng-content select="rt-icon-container" />
      <div layout-vertical layout-full-width>
        <div layout layout-space-between>
          <rt-heading class="heading" variant="large-x-dialog-header">
            @if (icon) {
              <rt-icon
                [name]="icon"
                [size]="iconSize()"
                [class.margin-around]="iconMarginLeft()"
                [class.margin-facing-text]="!iconMarginLeft()"
              />
            }
            @if (headingTpl) {
              <ng-container *ngTemplateOutlet="headingTpl" />
            } @else if (heading) {
              {{ heading }}
            }
            @if (hint) {
              <rt-icon-help [rtTooltip]="hint" [rtTooltipPosition]="'right'" />
            }
            <ng-container *ngTemplateOutlet="badgesTpl()" />
          </rt-heading>
          <span layout-no-wrap>{{ stepText() }}</span>
        </div>

        @if (subheadingTpl) {
          <ng-container *ngTemplateOutlet="subheadingTpl" />
        } @else if (subheading) {
          <div class="subheading">
            <div [innerHTML]="subheading"></div>
          </div>
        }
      </div>
    </div>
    <div class="actions">
      <ng-container *ngTemplateOutlet="actionsSlot()" />
      <ng-content select="rt-icon-button, rt-button" />
    </div>
  </div>
  <div layout layout-full-width>
    <ng-content />
  </div>
</div>
<ng-content select="rt-tabs" />
@if (hasDivider()) {
  <rt-divider />
}
